import { ReactNode } from "react";
import {
  ToggleButtonGroup as RACToggleButtonGroup,
  ToggleButtonGroupProps,
} from "react-aria-components";
import { toggleButtonGroup } from "./toggleButtonGroup.css";

interface IToggleButtonGroupProps extends ToggleButtonGroupProps {
  children: ReactNode;
}

const ToggleButtonGroup = ({
  children,
  disallowEmptySelection = true,
  ...props
}: IToggleButtonGroupProps) => {
  return (
    <RACToggleButtonGroup
      className={toggleButtonGroup}
      disallowEmptySelection={disallowEmptySelection}
      {...props}
    >
      {children}
    </RACToggleButtonGroup>
  );
};

export default ToggleButtonGroup;
